// Api.
import api from './Base';
import LoginsDataTable from "../types/LoginsDataTable";


const LoginApi = {

    getLogins:async (id?: number) => {

        let url = `login`;
        if (id) {
            url += `?id=${id}`
        }

        let logins: LoginsDataTable[] = [];

        await api.get<LoginsDataTable[]>(url)
            .then((response) => {
                logins = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve logins.', error);
            })
            .then(function () {});
        return logins;
    },

    getTags:async () => {

        let url = `login/tag`;

        let tags: any[] = [];

        await api.get<any[]>(url)
            .then((response) => {
                tags = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve tags.', error);
            })
            .then(function () {});
        return tags;
    },

    getAllTags:async () => {

        let url = `datasource/tag`;

        let tags: any[] = [];

        await api.get<any[]>(url)
            .then((response) => {
                tags = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve tags.', error);
            })
            .then(function () {});
        const uniqueTags = new Set();
        const uniqueObjects = [];

        for (const obj of tags) {
            if (!uniqueTags.has(obj.tagvalue)) {
                uniqueTags.add(obj.tagvalue);
                // Remove the id property from the object
                const { id, ...rest } = obj;
                uniqueObjects.push(rest);
            }
        }
        return uniqueObjects;
    },

}

export default LoginApi;